import { Injector } from '@angular/core';
import { CustomIcon } from '@examdojo/core/tiptap';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { CustomIconNodeComponent } from './custom-icon-node.component';

export const CustomIconExtension = (injector: Injector) => {
  return CustomIcon.extend({
    addNodeView() {
      return AngularNodeViewRenderer(CustomIconNodeComponent, {
        injector,
      });
    },
  });
};
